import { useState, useEffect } from 'react';
import { workflowService, WorkflowDropdownItem } from '@/services/features/WorkflowService';
import { useAuth } from '@/contexts/AuthContext';

export interface UseWorkflowsListResult {
  workflows: WorkflowDropdownItem[];
  loading: boolean;
  error: string | null;
}

export const useWorkflowsList = (): UseWorkflowsListResult => {
  const { hasuraToken } = useAuth();
  const [workflows, setWorkflows] = useState<WorkflowDropdownItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchWorkflows = async () => {
      if (!hasuraToken) {
        setError('Authentication required');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await workflowService.getAllWorkflowsForDropdown(hasuraToken);

        if (response.success) {
          setWorkflows(response.data);
          setError(null);
        } else {
          setError(response.error || 'Failed to fetch workflows');
        }
      } catch (err: any) {
        setError(err.message || 'Failed to fetch workflows');
      } finally {
        setLoading(false);
      }
    };

    fetchWorkflows();
  }, [hasuraToken]);

  return {
    workflows,
    loading,
    error
  };
};
